import { useEffect, useState } from "react";
import { adminApi } from "../api/adminApi";
import AdminSidebar from "../components/AdminSidebar";
import Message from "../components/Message";

export default function AdminUsers() {
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
  });
  const [admins, setAdmins] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    try {
      const data = await adminApi.getUsers();
      setAdmins(data.admins || []);
      setCustomers(data.customers || []);
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      await adminApi.createAdmin(form);
      setForm({ first_name: "", last_name: "", email: "", password: "" });
      setNotice({ type: "success", text: "Admin account created successfully!" });
      loadUsers();
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1>Users Management</h1>
        </div>
        <Message notice={notice} />

        <div className="admin-section">
          <h2>Create New Admin Account</h2>
          <form onSubmit={handleSubmit} className="admin-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="first_name">First Name</label>
                <input type="text" id="first_name" required className="form-control" value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} />
              </div>
              <div className="form-group">
                <label htmlFor="last_name">Last Name</label>
                <input type="text" id="last_name" required className="form-control" value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="admin_email">Email Address</label>
              <input type="email" id="admin_email" required className="form-control" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>

            <div className="form-group">
              <label htmlFor="admin_password">Password</label>
              <input type="password" id="admin_password" required className="form-control" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
              <small className="password-help">Minimum 8 characters, must contain uppercase letter and number</small>
            </div>

            <button type="submit" className="btn btn-primary">Create Admin Account</button>
          </form>
        </div>

        <div className="admin-section">
          <h2>Admin Accounts ({admins.length})</h2>
          {admins.length > 0 ? (
            <table className="admin-table">
              <thead><tr><th>Email</th><th>Name</th><th>Created Date</th></tr></thead>
              <tbody>
                {admins.map((admin) => (
                  <tr key={admin.id || admin.email}>
                    <td>{admin.email}</td>
                    <td>{admin.first_name} {admin.last_name}</td>
                    <td>{admin.created_at ? new Date(admin.created_at).toLocaleDateString() : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p>No admin accounts found.</p>}
        </div>

        <div className="admin-section">
          <h2>Customers ({customers.length})</h2>
          {customers.length > 0 ? (
            <table className="admin-table">
              <thead><tr><th>Email</th><th>Name</th><th>City</th><th>Joined Date</th></tr></thead>
              <tbody>
                {customers.map((customer) => (
                  <tr key={customer.id || customer.email}>
                    <td>{customer.email}</td>
                    <td>{customer.first_name} {customer.last_name}</td>
                    <td>{customer.city || "N/A"}</td>
                    <td>{customer.created_at ? new Date(customer.created_at).toLocaleDateString() : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <p>No customers found.</p>}
        </div>
      </div>
    </div>
  );
}
